import { Grid, Typography } from "@mui/material";
import Lista_Pasos from "./SubComponentes/Lista_Pasos";
import { useResponsive } from "../../../Modulo_Responsive/Hooks/useResponsive";
import PhoneOutlinedIcon from "@mui/icons-material/PhoneOutlined";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";

const pasos = [
    {
        numero: "1",
        titulo: "Contáctanos",
        descripcion: "Cuéntanos tu caso y agendamos la visita.",
        icono: PhoneOutlinedIcon,
    },
    {
        numero: "2",
        titulo: "Evaluamos",
        descripcion: "Realizamos la inspección técnica de tu vivienda o edificación.",
        icono: HomeOutlinedIcon,
    },
    {
        numero: "3",
        titulo: "Analizamos",
        descripcion: "Detectamos posibles afectaciones y evaluamos los riesgos.",
        icono: SearchOutlinedIcon,
    },
    {
        numero: "4",
        titulo: "Orientamos",
        descripcion: "Te entregamos un informe con recomendaciones y próximos pasos.",
        icono: DescriptionOutlinedIcon,
    },
];

const Pasos_Proceso = ({ titulo = "" }) => {
    const { sCell } = useResponsive();

    return (
        <Grid
            container
            justifyContent="center"
            alignItems="center"
            size={{ xs: 12 }}
            sx={{ backgroundColor: "#fff" }}
        >
            <Grid
                container
                justifyContent="center"
                alignItems="center"
                direction="column"
                size={{ xs: 12, sm: 12, md: 10 }}
                sx={{ maxWidth: 1400, mx: "auto", px: 3, }}
            >
                <Grid
                    container
                    justifyContent={'center'}
                    alignItems={'center'}
                    size={{ xs: 12, sm: 12, md: 12 }}
                >
                    <Typography
                        component="h2"
                        variant="h2"
                        sx={{
                            pr: sCell?0:3,
                            textAlign: 'center',
                            pb:4,
                        }}
                        itemProp="name"
                    >
                        Como funciona
                    </Typography>
                </Grid>

                <Grid container justifyContent="center" alignItems="center" size={{ xs: 12 }}>
                    <Lista_Pasos pasos={pasos} />
                </Grid>
            </Grid>
        </Grid>
    );
};

export default Pasos_Proceso;